"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
function default_1(paymentDetail) {
    const lastPaymentStatus = (0, _1.getLastPaymentStatus)(paymentDetail);
    const isRefundRequestOrComplete = lastPaymentStatus === 'refundRequest' || lastPaymentStatus === 'refundComplete';
    const { has_refund, waybill, room_is_deleted, room_status_cd_id } = paymentDetail;
    return (!isRefundRequestOrComplete &&
        !has_refund &&
        !(waybill === null || waybill === void 0 ? void 0 : waybill.code) &&
        !room_is_deleted &&
        room_status_cd_id !== 'ROOM_STATUS_06');
}
exports.default = default_1;
